import { combineReducers } from 'redux';
import { reducer as blogManagerReducer } from './blogManager';
import { reducer as pointsManagerReducer } from './pointsManager';
import { reducer as userManagerReducer } from './userManager';
import {reducer as promoManagerReducer} from './promoManager'
import {reducer as emailManagerReducer} from './emailManager'
export default combineReducers({
  pointsManager: pointsManagerReducer,
  userManager: userManagerReducer,
  blogManager: blogManagerReducer,
  promoManager: promoManagerReducer,
  emailManager: emailManagerReducer
});